<template>
  <div
    class="generalSidebarNew"
    :style="{ display: (foldSidebarNew == true ? 'none' : 'inline-block') }"
  >
    <div class="sidebar-list">
      <!-- <span>plantidCurTo: {{plantidCurTo}}</span> -->
      <!-- <span>$route.query：{{$route.query}}</span> -->

      <!-- 添加设备 -->
      <el-button
        type
        icon="el-icon-add"
        @click="dialogDataloggerVisible = true"
      >{{ $t('datalogger.add') }}</el-button>
      <div class="spliteline"></div>
      <!-- 搜索设备名称/PN码(可切换) -->
      <!-- <el-input
        :placeholder="$t('project.placeholder')"
        prefix-icon="el-icon-search"
        v-model="search.search"
        style="width:206px;"
        class="search-input"
        @keyup.enter.native="getDeviceList"
      >
        <el-select 
          v-model="search.searchSelect" 
          slot="prepend" 
          placeholder="请选择"
          popper-class="select-search-change"
        >
          <el-option label="SN" value="1"></el-option>
          <el-option label="PN" value="2"></el-option>
        </el-select>
      </el-input>-->

      <div class="searchBox">
        <!-- <span 
          class="preIcon"
          :class="{
            'preIconSn': search.searchSelect == 'SN',
            'preIconPn': search.searchSelect == 'PN'
          }"
        ></span>-->
        <!-- <el-tooltip
          effect="dark" 
          :content="$t('project.tipSearchSN')" 
          placement="top-start"
        >
          <span 
            v-show="search.searchSelect == 'SN'"
            class="preIcon preIconSn"
          ></span>
        </el-tooltip>
        <el-tooltip 
          effect="dark" 
          :content="$t('project.tipSearchPN')" 
          placement="top-start"
        >
          <span 
            v-show="search.searchSelect == 'PN'"
            class="preIcon preIconPn"
          ></span>
        </el-tooltip>-->
        <i class="el-icon-search" @click="getDeviceList()"></i>
        <el-input
          :placeholder="$t('project.placeholder')"
          v-model="search.search"
          class="input-with-select"
          @keyup.enter.native="getDeviceList"
        >
          <!-- placeholder="请选择" -->
          <!-- <el-select 
            placeholder=""
            v-model="search.searchSelect" 
            slot="prepend" 
            popper-class="select-search-recharge select-search-snpn"
          >
            按设备搜索
            <el-tooltip 
              effect="dark" 
              :content="$t('project.tipSearchSN')" 
              placement="right-start"
            >
              label="SN" value="SN"
              <el-option label="" value="SN">
                <i class="ico ico-sn"></i>
                <span>1</span>
              </el-option>
            </el-tooltip>
            按数采器搜索
            <el-tooltip 
              effect="dark" 
              :content="$t('project.tipSearchPN')" 
              placement="right-start"
            >
              label="PN" value="PN"
              <el-option label="" value="PN">
                <i class="ico ico-pn"></i>
                <span>1</span>
              </el-option>
            </el-tooltip>
          </el-select>-->
          <!-- 搜索按钮 -->
          <!-- <el-button 
            slot="append" 
            icon="el-icon-search"
            @click="getDeviceList"
          ></el-button>-->
        </el-input>
      </div>

      <!-- 项目切换 -->
      <!-- @visible-change="changeProValue" -->
      <el-dropdown placement="right-start" @command="changePro" class="el-dropdown-pro">
        <span class="showlabel">
          <span class="countbox">
            <i
              class="iconfont icon-xiangmuguanli"
              style="font-size:24px;margin-right:10px;vertical-align: middle;"
            ></i>
            <!-- {{proCurrentName}} -->
            <!-- {{`${proCurrentNameShow} (${deviceList.length}/50)`}} -->
            <span class="pnamebox">
              <span class="pname">{{ proCurrentNameShow }}</span>
            </span>
            <!-- {{`(${deviceList.length}/50)`}} -->
            {{ `( ${deviceList.length} )` }}
          </span>
          <i class="el-icon-arrow-right el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="el-dropdownmenu-pro">
          <el-dropdown-item
            v-for="item in proList"
            :command="item.pid"
            :key="item.pid"
            :class="{ selected: proCurrentPid == item.pid }"
          >{{ item.pname }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="viewbox">
        <span class="screen">
          <!-- 筛选 -->
          <!-- v-model="search" -->
          <!-- v-model="search.status" -->
          <!-- @change="getDeviceList(true)" -->
          <!-- <span class="shaixuan">{{$t('project.choice')}}</span> -->

          <!-- v-model="search" -->
          <!-- <el-select placeholder="" v-model="search.status" popper-class="select-search-pro">
            <el-option-group
              v-for="group in searchOptions"
              :key="group.label"
              :label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-option-group>
          </el-select>-->

          <!-- 单条件 -->
          <el-select
            v-model="search.status"
            @change="getDeviceList"
            :placeholder="$t('project.choice')"
            popper-class="select-search-pro"
            class="selectClearNew"
            clearable
          >
            <el-option
              v-for="(item, key) in $filter.deviceStatus"
              :key="key"
              :value="key"
              :label="item.label"
              style="display:flex;padding-left:40px;align-items:center;"
            >
              <i style="width:10px;height:10px;margin-right:8px;" :class="item.class"></i>
              <!-- :style="{'margin-left': key==0 ? '-8px' :'8px'}" -->
              <span class="select-label">{{ item.label }}</span>
            </el-option>
          </el-select>

          <!-- 多条件 -->
          <!-- <el-popover
            placement="top-start"
            title=""
            width="200"
            trigger="hover"
            content=""
          >
            <el-button slot="reference">筛选</el-button>
          </el-popover>-->
        </span>
        <span class="mode">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('project.tipCard')"
            placement="bottom-end"
          >
            <span
              class="modeleft modecell"
              :class="{ showmodeleft: showmode == 1 }"
              @click="showmode = 1;"
            ></span>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('project.tipList')"
            placement="bottom-end"
          >
            <span
              class="moderight modecell"
              :class="{ showmoderight: showmode == 2 }"
              @click="showmode = 2;"
            ></span>
          </el-tooltip>
        </span>
      </div>
      <!-- 显示模式-1 -->
      <!-- style="width: 247px;" -->
      <!-- style="overflow-y:scroll;padding-bottom:120%;" -->
      <el-table
        v-show="showmode == 1"
        :data="deviceList"
        stripe
        border
        height="100%"
        :row-style="{ height: 0 }"
        :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: '#F2F5F7', color: '#606266' }"
        element-loading-spinner="el-icon-loading"
        v-loading="loadingSideDevice"
        :show-header="hiddenTableHeader"
        style="overflow-y:auto;"
        class="proDeviceList"
      >
        <!-- :empty-text="$t('message.nodata')" -->
        <el-table-column>
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            <div class="device-item" @click="enterDevice(scope.row)">
              <span class="device-item-mask"></span>
              <span class="device-item-info">
                <span class="device-item-namebox">
                  <!-- <i class="status-icon status-normal"></i> -->
                  <i class="status-icon" :class="$filter.deviceStatus[scope.row.status].class"></i>
                  <!-- // 跑马灯样式 -->
                  <!-- <span class="device-item-name"><span class="marquee-text">{{ scope.row.devalias }}</span></span> -->
                  <span class="device-item-name">{{ scope.row.devalias }}</span>
                </span>
                <span class="device-item-idbox">
                  <span class="device-item-id">
                    SN:
                    <span class="item-num">{{ scope.row.deviceSn||scope.row.sn }}</span>
                  </span>
                  <span class="device-item-id">
                    PN:
                    <span class="item-num">{{ scope.row.pn }}</span>
                  </span>
                </span>
                <span
                  class="device-item-follow showFollow"
                  :style="{ display: (scope.row.focus == true ? 'inline-block' : '') }"
                  :class="{}"
                  @click="followDevice(scope.row)"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="`${scope.row.focus ? $t('device.unfollow') : $t('device.follow')}`"
                    placement="bottom-end"
                  >
                    <i class="followbase followno" :class="{ 'followyes': scope.row.focus }"></i>
                  </el-tooltip>
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 显示模式-2 -->
      <!-- style="width: 247px;" -->
      <!-- style="overflow-y:scroll;padding-bottom:130%;" -->
      <el-table
        v-show="showmode == 2"
        :data="deviceList"
        stripe
        border
        height="100%"
        :row-style="{ height: 0 }"
        :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: '#F2F5F7', color: '#606266' }"
        element-loading-spinner="el-icon-loading"
        v-loading="loadingSideDevice"
        :show-header="hiddenTableHeader"
        style="overflow-y:auto;"
        class="proDeviceList"
      >
        <el-table-column>
          <template slot-scope="scope">
            <div class="device-item-easy" @click="enterDevice(scope.row)">
              <i class="status-icon" :class="$filter.deviceStatus[scope.row.status].class"></i>
              <span class="device-item-namebox">
                <!-- <span class="device-item-name">{{scope.row.devalias || scope.row.sn}}</span> -->
                <span class="device-item-name" style="width:176px;">{{ scope.row.pn }}</span>
              </span>
              <span
                class="device-item-follow showFollow"
                :style="{ display: (scope.row.focus == true ? 'inline-block' : '') }"
                @click="followDevice(scope.row)"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="`${scope.row.focus ? $t('device.unfollow') : $t('device.follow')}`"
                  placement="bottom-end"
                >
                  <i class="followbase followno" :class="{ 'followyes': scope.row.focus }"></i>
                </el-tooltip>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 该盒占位修复侧栏列表滚动问题 -->
      <div style="width:100%;height:56px;"></div>

      <!-- 定位侧栏底部 -->
      <div class="project-box">
        <!-- 新建项目 -->
        <!-- @click="showCreateProject=true;" -->
        <button type="button" class="project-create" @click="createProject">
          <i class="iconfont icon-xinjianxiangmu"></i>
          <el-tooltip :content="$t('project.createProject')" placement="top">
            <span>{{ $t('project.createProject') }}</span>
          </el-tooltip>
        </button>
        <div class="project-line"></div>
        <!-- 项目管理 -->
        <button type="button" class="project-manage" @click="enterProject">
          <i class="iconfont icon-xiangmuguanli"></i>
          <el-tooltip :content="$t('project.manageProject')" placement="top">
            <span>{{ $t('project.manageProject') }}</span>
          </el-tooltip>
        </button>
      </div>
    </div>

    <!-- 添加数采器 -->
    <datalogger-dialog
      :visible.sync="dialogDataloggerVisible"
      v-if="dialogDataloggerVisible"
      @submitSucAdd="handleCreateSuc"
      @submitFailAdd="handleCreateFail"
    ></datalogger-dialog>
    <!-- 添加结果提示(成功) -->
    <!-- v-if="dataloggerAddSucVisible" -->
    <device-dialog
      :title="$t('datalogger.addResults')"
      :visible.sync="dataloggerAddSucVisible"
      :class="{ 'showDialog': dataloggerAddSucVisible, 'hideDialog': !dataloggerAddSucVisible }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.addedSuccessfully') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <div class="showoperate">
            <!-- 继续添加 -->
            <button
              type="button"
              class="btn btn-light"
              style="margin-right:10px;"
              @click="dataloggerAddSucVisible = false; dialogDataloggerVisible = true;"
            >
              {{ $t('datalogger.continueAdding')
              }}
            </button>
            <!-- 完成 -->
            <button type="button" class="btn btn-dark" @click="dataloggerAddSucVisible = false;">
              {{
              $t('datalogger.finish') }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 添加结果提示(失败) -->
    <!-- v-if="dataloggerAddFailVisible" -->
    <device-dialog
      :title="$t('datalogger.addResults')"
      :visible.sync="dataloggerAddFailVisible"
      :class="{ 'showDialog': dataloggerAddFailVisible, 'hideDialog': !dataloggerAddFailVisible }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <div class="showoperate">
            <!-- 暂不添加 -->
            <button
              type="button"
              class="btn btn-light"
              style="margin-right:10px;"
              @click="dataloggerAddFailVisible = false;"
            >{{ $t('datalogger.nowNoAdd') }}</button>
            <!-- 重新添加 -->
            <button
              type="button"
              class="btn btn-dark"
              @click="dataloggerAddFailVisible = false; dialogDataloggerVisible = true;"
            >
              {{ $t('datalogger.reAdd')
              }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!-- 新建项目 -->
    <!-- v-if="createProjectVisible" -->
    <device-dialog
      :title="$t('project.createProject')"
      :visible.sync="createProjectVisible"
      :class="{ 'showDialog': createProjectVisible, 'hideDialog': !createProjectVisible }"
      noFooter
    >
      <div slot="content">
        <el-form slot="content" class="grid" :rules="formDataRules" :model="pFormData" ref="pFormData">
          <el-form-item :label="`${$t('project.projectName')}:`" size="small" prop="name">
            <el-input v-model="pFormData.name" clearable></el-input>
          </el-form-item>
                        <el-form-item :label="`${$t('project.projectRemark')}:`" size="small">
                <el-input v-model="pFormData.remark" clearable></el-input>
              </el-form-item>
          <!-- 上传图片 -->
          <!-- <el-form-item label=" " prop="picSmall">
            <div style="text-align:center;">
              <img :src="pFormData.picSmall ? pFormData.picProjectPic : ''" />
            </div>
            <div class="upload-contents" v-if="upbtnVisible">
              <button
                type="button"
                class="upload-buttonEquipment"
                @click.prevent="$refs.fileUploader.click()"
              >
                <i class="iconfont icon-shangchuan1"></i>
              </button>
              <div class="upload-tip">{{ `${$t('project.upload')} (${$t('project.limit')})` }}</div>
              <input
                type="file"
                class="upload-input"
                ref="fileUploader"
                accept="image/jpeg, image/png"
                @change="uploadImage($event)"
              />
            </div>
          </el-form-item> -->
        </el-form>
        <div style="text-align:right;">
          <button
            type="button"
            class="btn btn-dark"
            @click="submitCreateProject"
          >{{ $t('device.confirm') }}</button>
        </div>
      </div>
    </device-dialog>
    <!-- 新建项目结果提示(成功) -->
    <!-- v-if="createProjectSucVisible" -->
    <device-dialog
      :title="$t('project.createResults')"
      :visible.sync="createProjectSucVisible"
      :class="{ 'showDialog': createProjectSucVisible, 'hideDialog': !createProjectSucVisible }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('project.createSuc') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="createProjectSucVisible = false;">
              {{
              $t('datalogger.confirm') }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 新建项目结果提示(失败) -->
    <!-- v-if="createProjectFailVisible" -->
    <device-dialog
      :title="$t('project.createResults')"
      :visible.sync="createProjectFailVisible"
      :class="{ 'showDialog': createProjectFailVisible, 'hideDialog': !createProjectFailVisible }"
      width="500px"
      noFooter
    >
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="createProjectFailVisible = false;">
              {{
              $t('datalogger.confirm') }}
            </button>
          </div>
        </div>
      </div>
    </device-dialog>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex';

// =======================
// 原有地图方案（国内：高德）
import dataloggerDialog from "@/components/dialognew/dataloggernew";
// 临时地图方案（国内：Leaflet+天地图）
// import dataloggerDialog from "@/components/dialognew/dataloggernewtemporary";
// =======================
import { mapGetters } from "vuex";
import deviceDialog from "@/components/dialognew";
import { i18n } from "@/i18n";
import config from '@/assets/js/config';
export default {
  components: {
    dataloggerDialog,
    deviceDialog
  },
  props: {
    // deviceList: {
    //   type: Array,
    //   default() {
    //     return []
    //   }
    // }
  },
  data() {
    return {
      foldSidebarNew: false, //时候异常侧边
      // statusDic: this.$filter.deviceStatus,
      // 创建数采器弹窗
      dialogDataloggerVisible: false,
      // 项目下设备列表
      deviceList: [],
      // 筛选条件
      search: {
        status: "",
        // brand: "",
        // pn: "",
        // 搜索内容
        search: "",
        // 搜索类别(可切换)
        searchSelect: "SN"
      },
      //分页数据
      pagination: {
        currentPage: 1,
        pagesize: 100,
        total: 0
      },
      selectedOption: "",
      searchOptions: [
        {
          label: "设备状态",
          options: [
            {
              label: "所有状态",
              value: "000"
              // name: 'normal',
              // class: 'status-normal',
            },
            {
              // label: i18n.t('statistic.normal'),
              label: "正常",
              value: "aaa"
              // name: 'normal',
              // class: 'status-normal',
            },
            {
              label: "离线",
              value: "bbb"
              // name: 'offline',
              // class: 'status-offline',
            }
          ]
          // options: this.$filter.deviceStatus
        },
        {
          label: "设备类型",
          // options: [{
          //   value: 'ccc',
          //   label: 'CCC'
          // }, {
          //   value: 'ddd',
          //   label: 'DDD'
          // }],
          options: this.$filter.deviceType
        }
      ],
      inputtxt: "",
      // 筛选-设备状态表($filter)
      deviceStatusNew: {
        0: {
          label: i18n.t("statistic.normal"),
          class: "status-normal",
          name: "normal"
        },
        1: {
          label: i18n.t("statistic.offline"),
          class: "status-offline",
          name: "offline"
        },
        2: {
          label: i18n.t("statistic.fault"),
          class: "status-fault",
          name: "fault"
        },
        3: {
          label: i18n.t("statistic.standby"),
          class: "status-standby",
          name: "standby"
        },
        4: {
          label: i18n.t("statistic.warning"),
          class: "status-warning",
          name: "warning"
        }
      },
      // 筛选-设备类型($filter)
      deviceTypeNew: {
        0: {
          value: "0",
          label: i18n.t("device.brand0")
        },
        1: {
          value: "1",
          label: i18n.t("device.brand1")
        },
        2: {
          value: "2",
          label: i18n.t("device.brand2")
        },
        3: {
          value: "3",
          label: i18n.t("device.brand3")
        }
      },
      // 显示模式
      showmode: 1,
      hiddenTableHeader: false,
      // 项目列表
      proList: [],
      // 当前选中项目名称
      proCurrentName: "",
      // 当前选中项目ID
      proCurrentPid: "",
      // 是否关注
      // focus: false,
      // 显示新建项目
      // showCreateProject: false,
      // 项目操作
      createProjectVisible: false,
      // 项目新建与编辑
      pFormData: {
        name: "",
        // picSmall: "",
        // picProjectPic: "",
        remark: ""
      },
      formDataRules: {
        name: [
          {
            required: true,
            message: this.$t("datalogger.cp10"),
            trigger: "blur"
          }
        ]
      },
      deciveAll: {
        pname: this.$t("statistic.totalDevice"),
        pid: ""
      },
      // 上传图片弹窗按钮
      upbtnVisible: true,
      // 数采器添加成功提示弹窗
      dataloggerAddSucVisible: false,
      // 数采器添加失败提示弹窗
      dataloggerAddFailVisible: false,
      // 新建项目成功提示弹窗
      createProjectSucVisible: false,
      // 新建项目失败提示弹窗
      createProjectFailVisible: false,
      // 操作返回提示
      dataloggerTipMsg: "",
      // 加载侧栏设备列表
      loadingSideDevice: false
    };
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo"
    }),
    // watchshowmode(){
    //   return this.showmode
    // },
    // deviceStatus () {
    //   return this.$filter.deviceStatus[this.deviceInfo.status]
    // },
    // 切换项目
    // proCurrentPidShow() {
    //   return this.proCurrentPid;
    // },
    // ...mapGetters({
    //   // 管理员要跳转普通用户查看项目ID
    //   plantidCurTo: 'getPlantidCurTo'
    // }),
    proCurrentNameShow() {
      var valer;
      this.proList.forEach(element => {
        if (element.pid == this.proCurrentPid) {
          valer = element.pname;
        }
      });
      // console.log('监听属性valer', valer);
      return valer || "";
    }
  },
  watch: {
    // 响应更新业主更新左侧SidebarNew
    "$store.state.event.foldGeneralSidebarNew"(val) {
      if (val) {
        this.foldSidebarNew = !this.foldSidebarNew;
        this.$store.state.event.foldGeneralSidebarNew = false;
      }
    },
    // 响应更新电站列表事件
    "$store.state.event.updateProjectList"(val) {
      if (val) {
        this.getProjectList(true);
        this.$store.state.event.updateProjectList = false;
      }
    }
    // 管理员要跳转普通用户查看项目ID
    // plantidCurTo: {
    //   handler (val) {
    //     console.log('watch-plantidCurTo', val.plantidCurTo);
    //     // if(val.plantidCur!=undefined) {
    //     //   this.getDeviceList()
    //     //   this.queryDeviceStatus()
    //     // }
    //   },
    //   deep: true
    // },
    // 'this.$route.query.pid'(val) {
    //   if(val) {
    //      console.log("[watch-pid]", val);
    //     // this.changePro(this.$route.query.pid);
    //   }
    // },
  },
  created() {
    this.getProjectList();

    // if(this.$route.query.pid){
    //   console.log("[changePro]");
    //   console.log("[changePro-pid]", this.$route.query.pid);
    //   this.changePro(this.$route.query.pid);
    // }
  },
  mounted() {
    // 跑马灯样式
    // this.$nextTick(() => {
    //   this.initMarquee();
    // });
  },
  updated() {
    // 跑马灯样式
    // this.$nextTick(() => {
    //   this.initMarquee();
    // });
  },
  methods: {
    // 跑马灯
    initMarquee() {
      const nameBoxes = this.$el.querySelectorAll('.device-item-name');
      nameBoxes.forEach(box => {
        const textEl = box.querySelector('.marquee-text');
        if (!textEl) return;
        // Reset
        textEl.style.animation = '';
        textEl.style.removeProperty('--marquee-start');
        textEl.style.removeProperty('--marquee-end');
        const boxWidth = box.clientWidth;
        const textWidth = textEl.scrollWidth;
        if (textWidth > boxWidth) {
          textEl.style.setProperty('--marquee-start', boxWidth + 'px');
          textEl.style.setProperty('--marquee-end', '-' + textWidth + 'px');
          const totalDistance = boxWidth + textWidth;
          const duration = Math.max(1, totalDistance / 150);
          textEl.style.animation = `marquee-scroll ${duration}s linear infinite`;
        }
      });
    },
    //获取项目列表数据
    getProjectList(reset) {
      // this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // page: 0,
        // pagesize: this.paginationPro.pagesize,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
        devtype: 2304,
        // plantName: this.search.search,
        i18n: this.$lang.currentLang
        // ...this.search,
      };

      // queryPlantsInfoEs => queryPlantCollDevEs
      this.loadingSideDevice = true;
      this.$request.get("queryPlantsInfoEs", param).then(res => {
        if (res.err == 0) {
          this.proList = res.dat.info;
          this.proList.unshift(this.deciveAll);

          // 管理员跳转普通用户时传递项目ID
          if (this.$route.query.pid) {
            // 指定
            this.proCurrentPid = this.$route.query.pid;
            this.proCurrentName = this.$route.query.pname;
          } else {
            if (this.deviceInfo.pid) {
              this.proCurrentPid = this.deviceInfo.pid;
            } else {
              // 默认显示第一个
              this.proCurrentPid = this.proList[0].pid;
              this.proCurrentName = this.proList[0].pname;
            }
          }
          // 请求项目下设备列表
          let param2 = {
            pid: this.proCurrentPid,
            devtype: 2304,
            page: 1,
            pageSize: 500,
            orderBy: "descfocus"
          };
          this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param2).then(res => {
            if (res.code == 0 && Array.isArray(res.data && res.data.items) && res.data.items.length > 0) {
              this.deviceList = this.Fnreturndev(res);
              this.loadingSideDevice = false;
              this.deviceList.forEach(item => {
                if (
                  item.pn == this.$route.query.pn &&
                  item.sn == this.$route.query.sn
                ) {
                  this.$store.commit("saveDeviceInfo", {
                    pn: item.pn,
                    sn: item.sn,
                    deviceSn: item.deviceSn || item.sn,
                    devaddr: item.devaddr,
                    devcode: item.devcode,
                    status: item.status,
                    devalias: item.devalias,
                    pid: item.pid,
                    focus: item.focus,
                    usr: item.usr,
                    uid: item.uid,
                    // 增
                    brand: item.brand,
                    // 增
                    devtype: item.devtype,
                    // 增
                    device_Firmware_Version: item.fireware,
                    profitToday: item.profitToday,
                    profitTotal: item.profitTotal,
                    sellProfitToday: item.sellProfitToday,
                    sellProfitTotal: item.sellProfitTotal,
                    buyProfitToday: item.buyProfitToday,
                    buyProfitTotal: item.buyProfitTotal,
                    otaLabel: item.otaLabel,
                  });
                }
              });
            } else {
              // this.$message.warning(this.$t(`errCode.${res.err}`));
              this.deviceList = [];
              this.loadingSideDevice = false;
            }
          }).catch(() => {
            this.deviceList = [];
            this.loadingSideDevice = false;
          });
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.loadingSideDevice = false;
        }
      });
    },
    // 切换项目
    changePro(proCurrentPid) {
      this.search.status = "";
      this.search.search = "";
      this.proCurrentPid = proCurrentPid;
      let param = {
        pid: proCurrentPid,
        devtype: 2304,
        page: 1,
        pageSize: 500,
        orderBy: "descfocus"
      };
      this.loadingSideDevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code == 0) {
          // 根据返回数据格式
          this.deviceList = this.Fnreturndev(res);
          this.loadingSideDevice = false;
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.deviceList = [];
          this.loadingSideDevice = false;
        }
      }).catch(() => {
        this.deviceList = [];
        this.loadingSideDevice = false;
      });
    },
    //获取项目下设备列表数据
    // status，devtype(2304)， plantid，page(0)，pagesize (100)
    getDeviceList() {
      // SN:1,PN:2
      // console.log("cur-sn/pn", this.search.searchSelect);
      // return;
      let typeObj = {};
      if (this.search.searchSelect == "SN") {
        // typeObj = { sn: this.search.search }
        typeObj = { search: this.search.search };
      } else if (this.search.searchSelect == "PN") {
        typeObj = { pn: this.search.search };
      }

      let param = {
        pid: this.proCurrentPid,
        // ...this.search,
        deviceStatus: this.search.status,
        // brand: this.search.brand,
        // 按SN或PN搜索
        ...typeObj,
        devtype: 2304,
        page: 1,
        pageSize: 500,
        orderBy: "descfocus"
      };
      this.loadingSideDevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code == 0) {
          // 新接口返回值转换为旧接口设备列表结构
          this.deviceList = this.Fnreturndev(res);
          this.loadingSideDevice = false;
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.deviceList = [];
          this.loadingSideDevice = false;
        }
      }).catch(() => {
        this.deviceList = [];
        this.loadingSideDevice = false;
      });
    },
    toggleDevice(info) {
      this.$store.commit("saveDeviceInfo", { ...info, deviceSn: info.deviceSn || info.sn });
    },
    handleCommand(command) {
      this.$message("点击" + command);
    },
    // 关注 (info)
    // pn/sn/devaddr/devcode/focus(true,false)
    followDevice(info) {
      // this.focus = !this.focus;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        // focus: info.focus == undefined ? true : info.focus,
        focus: !info.focus
      };
      this.$request.get("editDeviceFocusEs", param).then(res => {
        if (res.err === 0) {
          // 保存设备信息
          this.$store.commit("saveDeviceInfo", {
            pn: info.pn,
            sn: info.sn,
            deviceSn: info.deviceSn || info.sn,
            devaddr: info.devaddr,
            devcode: info.devcode,
            status: info.status,
            devalias: info.devalias,
            focus: info.focus,
            // pid: info.pid,
            // 增
            brand: info.brand,
            // 增
            devtype: info.devtype,
            // 增
            device_Firmware_Version: info.fireware,
            profitToday: info.profitToday,
            profitTotal: info.profitTotal,
            sellProfitToday: info.sellProfitToday,
            sellProfitTotal: info.sellProfitTotal,
            buyProfitToday: info.buyProfitToday,
            buyProfitTotal: info.buyProfitTotal,
            otaLabel: info.otaLabel,
          });
          // 通知设备关注更新
          this.$store.state.event.updateFocus = true;
          // 通知项目列表更新
          this.$store.state.event.updateProjectList = true;
          // this.getProjectList();
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 添加数采器成功回调
    handleCreateSuc() {
      // this.$message.success(this.$t("datalogger.addSuc"));
      // this.dataloggerTipMsg = val;
      this.dataloggerAddSucVisible = true;
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      // 通知侧栏项目列表更新
      this.$store.state.event.updateProjectList = true;
      // // 获取项目列表
      // this.getProjectList();
      // this.$router.push({
      //   path:'/generalNew/setting/datalogger',
      //   query: {'notice': 'Suc'}
      // });
    },
    // 添加数采器失败回调
    handleCreateFail(val, name) {
      // console.log(name.split("(")[1].split(")")[0]);

      if(name){
        // this.dataloggerTipMsg = this.$t('datalogger.dataloggerTipName')+name.split("(")[1].split(")")[0];
        // 兼容中英文括号，提取失败则回退到原始文案
        const matched = String(name).match(/[(（]([^)）]*)[)）]/);
        this.dataloggerTipMsg = matched
          ? this.$t('datalogger.dataloggerTipName') + matched[1]
          : val;
      }else{
        this.dataloggerTipMsg = val;
      }
      this.dataloggerAddFailVisible = true;
      // this.$router.push({
      // 	path:'/generalNew/setting/datalogger',
      // 	query: {'notice': 'Fail', 'noticeVal': val}
      // });
    },
    // 进入项目管理
    enterProject() {
      this.$router.push({ path: "/generalNew/project" });
    },
    // 新建项目
    createProject() {
      this.createProjectVisible = true;
      // this.upbtnVisible = true;
      // this.pFormData.name ='';
      this.$set(this.pFormData, "name", "");
      this.$set(this.pFormData, "remark", "");
      // this.$set(this.pFormData, "picSmall", "");
      this.$refs.pFormData.resetFields();
    },
    submitCreateProject() {
      this.$refs.pFormData.validate(valid => {
        if (!valid) return false;
              let param = {
        name: this.pFormData.name,
        remark: this.pFormData.remark,
        itemType: 5,
        businessId: "4",
        timezone: '28800',
      };
      this.$request.postMicroserDess("/dgm/api/auth/web/itemseybond/saveNewItemForDIS", param).then(res => {
        if (res.code == 0) {
          this.$store.state.event.updateProjectList = true;
          // this.getProjectList();
          this.createProjectVisible = false;
          this.createProjectSucVisible = true;
        }else{
          this.dataloggerTipMsg = res.message||res.errorMessage;
          this.createProjectFailVisible = true;
        }
      });
      // let param = {
      //   name: this.pFormData.name,
      //   // picSmall: this.pFormData.picSmall
      // };
      // this.$request.get("addPlantEs", param).then(res => {
      //   if (res.err == 0) {
      //     // this.$message.success(this.$t("project.modifySuc"));
      //     // 通知项目列表更新
      //     this.$store.state.event.updateProjectList = true;
      //     this.getProjectList();
      //     this.createProjectVisible = false;
      //     this.createProjectSucVisible = true;
      //   } else {
      //     // this.$message.error(this.$t(`errCode.${res.err}`));
      //     this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
      //     this.createProjectFailVisible = true;
      //   }
      // });
    });
    },
    // 点击进入设备
    enterDevice(info) {
      // console.log("点击保存info",info);
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        devalias: info.devalias,
        status: info.status,
        focus: info.focus,
        // 增
        brand: info.brand,
        // 增
        devtype: info.devtype,
        // 增
        device_Firmware_Version: info.fireware,
        // 增
        collalias: info.collalias,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
        otaLabel: info.otaLabel,
      });
    },
    // 项目图片系统中没有用到，暂时去掉
    // // 上传图片
    // uploadImage(event) {
    //   let file = event.target.files[0];
    //   if (file.size > 1 * 1024 * 1024) {
    //     this.$message.error(this.$t("createPlant.fileExceed"));
    //     return;
    //   }
    //   this.$request.uploadImage(file).then(res => {
    //     if (res.err === 0) {
    //       // console.log('侧边栏新建项目上传图片成功', res.dat)
    //       this.$message.success(this.$t("createPlant.uploadSuccess"));
    //       this.upbtnVisible = false;
    //       // this.pFormData.picSmall = res.dat.picSmall;
    //       this.$set(this.pFormData, "picSmall", res.dat.picSmall);
    //       let defaultsBaseURL = config.env == "production" ? document.location.protocol + '//img.shinemonitor.com/' : document.location.protocol + '//solar.test.eybond.com/'
    //       this.$set(this.pFormData, "picProjectPic", res.dat.picSmall.includes('http')?res.dat.picSmall:defaultsBaseURL +res.dat.picSmall);
    //       // this.$nextTick(() => {
    //       //   this.upbtnVisible = true;
    //       // });
    //       // this.$emit("update:picSmall", res.dat.picSmall)
    //     }
    //   });
    // }
  }
};
</script>
<style lang="less" scoped>
.generalSidebarNew {
  width: 264px;

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .sidebar-list {
    box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.2);
    height: 100%;
    padding: 0 20px;
    background-color: rgb(34, 45, 53);
    color: #ffffff;
    font-size: 16px;
    padding-top: 20px;
    position: relative;
    // 解决侧栏列表滚动问题
    display: flex;
    flex-direction: column;

    // 添加按钮
    /deep/.el-button {
      display: block;
      width: 100%;
      height: 38px;
      min-height: 38px;
      max-height: 38px;
      border: none;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgb(34, 45, 53);
      font-size: 16px;
      margin-bottom: 20px;
      padding: 0;
    }

    /deep/.el-button .el-icon-add:before {
      content: "";
      display: inline-block;
      height: 16px;
      width: 16px;
      background: url(../../../assets/img/general/Icon_Device_Add.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }

    /deep/.el-icon-add {
      vertical-align: middle;
    }

    // 分割线
    .spliteline {
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
      margin-bottom: 20px;
    }

    // 搜索框
    // /deep/.search-input.el-input {
    //   display: block;
    //   font-size: 16px;
    // }
    // /deep/.search-input.el-input .el-input__inner {
    //   margin-bottom: 20px;
    //   height: 42px;
    //   padding-left: 42px;
    //   color: #ffffff;
    // }
    // /deep/.search-input .el-input__inner{
    //   background-color: transparent;
    //   border-radius: 0;
    //   border: 1px solid @primaryTextColor;
    // }
    // /deep/.search-input .el-input__inner:hover{
    //   border:1px solid @primaryTextColor;
    // }
    // /deep/.search-input .el-input__inner:focus{
    //   border:1px solid @primaryTextColor;
    // }
    // // .el-input__suffix
    // /deep/.search-input .el-input__prefix {
    //   left: 14px;
    //   height: auto;
    // }
    // /deep/.search-input .el-input__icon {
    //   color: #ffffff;
    //   font-size: 20px;
    //   line-height: 42px;
    // }
    // /deep/.search-input input::-webkit-input-placeholder {
    //   font-weight: 100;
    //   color: #ffffff;
    // }
    // /deep/.search-input input::-moz-input-placeholder {
    //   font-weight: 100;
    //   color: #ffffff;
    // }
    // /deep/.search-input input::-ms-input-placeholder {
    //   font-weight: 100;
    //   color: #ffffff;
    // }
    // 搜索盒子
    .searchBox {
      // width: 206px;
      width: 100%;
      border: 1px solid @primaryTextColor;

      margin-bottom: 10px;
      position: relative;
      display: flex;
      align-items: center;

      .el-icon-search {
        cursor: pointer;
        width: 16px;
        height: 16px;
        margin: 0 10px 0 15px;
      }

      // 前置图标
      /deep/.el-input__suffix {
        right: 14px;
      }

      /deep/.el-input__icon {
        width: 16px;
      }

      .preIconSn {
        background: url(../../../assets/img/general/Search_Select_Device.png)
          rgb(34, 45, 53);
      }

      .preIconPn {
        background: url(../../../assets/img/general/Search_Select_Datalogger.png)
          rgb(34, 45, 53);
      }

      .preIcon {
        position: absolute;
        top: 1px;
        left: 1px;
        display: inline-block;
        width: 36px;
        height: 40px;
        // background: red;
        z-index: 2;
        background-repeat: no-repeat;
        background-size: 24px 24px;
        background-position: center;
      }

      /deep/.el-input-group {
        line-height: 40px;
      }

      // 前置
      /deep/.el-input-group__prepend {
        width: 30%;
        padding: 0px 8px;
        background-color: transparent;
        color: #ffffff;
        border-color: @primaryTextColor;
        border-radius: 0px;
      }

      // 前置-下拉框
      /deep/.el-input-group__prepend .el-select {
        margin: -10px -20px -10px -12px;
      }

      // 后置
      /deep/.el-input-group__append {
        padding: 0px 14px;
        background-color: transparent;
        color: #ffffff;
        border-color: @primaryTextColor;
        border-radius: 0px;
      }

      // 后置-搜索按钮
      /deep/.el-input-group__append .el-button {
        display: inline-block;
        height: auto;
        margin-bottom: 0px;
        margin: -8px;
        background-color: transparent;
        color: #ffffff;
      }

      // 输入框
      /deep/.el-input__inner {
        // border: 0;
        border: none;
        height: 42px;
        line-height: 42px;
        background-color: transparent;
        // border-radius: 0px;
        color: #ffffff;
        // border-left: none;
        // border-right: none;
        padding-left: 6px;
      }

      /deep/.el-input__inner:hover {
        border: 1px solid @primaryTextColor;
        border: none;
        // border-right: none;
      }

      /deep/.el-input__inner:focus {
        border: 1px solid @primaryTextColor;
        border: none;
        // border-right: none;
      }

      // 下拉框
      /deep/.el-select .el-input__inner {
        background-color: transparent;
        border-radius: 0px;
        border: none;
      }

      // 三角
      /deep/.el-icon-arrow-up:before {
        content: "";
        display: inline-block;
        width: 20px;
        height: 42px;
        background: url(../../../assets/img/general/Icon_Down.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        transform: rotate(180deg);
      }

      /deep/.el-select .el-input .el-select__caret.is-reverse {
        transform: rotate(180deg);
      }
    }

    // 项目列表
    /deep/.el-table .cell {
      // padding: 0 40px 0 0;
      padding: 0px;
    }

    /deep/.el-table__expand-icon > .el-icon {
      margin-top: -6px;
    }

    /deep/.el-table .cell,
    /deep/.el-table th div {
      overflow: inherit;
    }

    /deep/.el-table__body .el-table__row .el-table_1_column_2 .cell.el-tooltip {
      font-size: 16px;
      text-align: right;
    }

    /deep/.el-table__body .el-table__row .el-table_2_column_4 .cell.el-tooltip {
      font-size: 16px;
      text-align: right;
    }

    /deep/.el-table__body .el-table__row.expanded .cell.el-tooltip {
      color: @primaryTextColor;
    }

    /deep/.el-table__body .el-table__row.expanded .cell.el-tooltip {
      color: @primaryTextColor;
    }

    /deep/.el-table__body
      .el-table__row.expanded
      .el-table__expand-icon
      > .el-icon {
      color: @primaryTextColor;
    }

    /deep/.el-table,
    .el-table__expanded-cell {
      background: transparent;
      border: none;
      color: #ffffff;
    }

    /deep/.el-table--border td {
      border: none;
    }

    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0;
    }

    /deep/.el-table__expanded-cell[class*="cell"] {
      padding: 0;
    }

    /deep/.el-table--scrollable-x .el-table__body-wrapper:last-child {
      overflow-x: hidden;
    }

    /deep/.el-table .cell.el-tooltip {
      text-align: right;
      padding: 0;
    }

    /deep/.el-table th,
    .el-table tr {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table__body tr,
    .el-table__body td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table--enable-row-transition .el-table__body td {
      border: none;
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table,
    .el-table__expanded-cell {
      background-color: rgb(34, 45, 53);
      border: none;
    }

    /deep/.el-table__row.hover_row {
      border: none;
    }

    /deep/.el-table__body-wrapper .el-table__expand-icon > .el-icon {
      color: #ffffff;
    }

    .viewbox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      // width: 247px;
      /deep/.el-select .el-input .el-input__icon.el-icon-circle-close {
        margin-top: 5px;
      }

      .screen {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // width: 50px;
        max-width: 50%;
        min-width: 35%;
        height: 34px;
        position: relative;

        .shaixuan {
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          line-height: 34px;
          background: #202d35;
          color: #ffffff;
          font-size: 16px;
          z-index: 1;
          cursor: pointer;
        }

        .el-select {
          position: absolute;
          top: 0;
          left: 0;
        }

        /deep/.el-input__inner {
          background: #202d35;
          border: none;
          padding: 0px 5px;
          font-size: 16px;
          color: #ffffff;
        }

        /deep/.el-input__prefix,
        /deep/.el-input__suffix {
          top: -4px;
          right: -20px;
          background: #202d35;
        }

        /deep/.el-icon-arrow-up:before {
          content: "";
          display: inline-block;
          width: 20px;
          height: 24px;
          background: url(../../../assets/img/general/Icon_Down.png);
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          transform: rotate(180deg);
        }

        /deep/.el-select .el-input .el-select__caret.is-reverse {
          transform: rotate(180deg);
        }
      }

      .mode {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .modeleft {
          background-image: url(../../../assets/img/general/Icon_Mode_Dark_L.png);
        }

        .showmodeleft {
          background-image: url(../../../assets/img/general/Icon_Mode_Light_L.png);
        }

        .moderight {
          background-image: url(../../../assets/img/general/Icon_Mode_Dark_R.png);
        }

        .showmoderight {
          background-image: url(../../../assets/img/general/Icon_Mode_Light_R.png);
        }

        .modecell {
          width: 34px;
          height: 34px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
    }

    // 关注
    .device-item-follow {
      // display: none;
      position: absolute;
      top: 0px;
      right: 0px;
      width: 40px;
      height: 40px;
      border-radius: 0 0 0 100%;

      // background:#858F97;
      // 是否关注
      .followno {
        width: 20px;
        height: 20px;
        background-image: url(../../../assets/img/general/Icon_Operate_Follow_Light.png);
      }

      .followyes {
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/img/general/Icon_Operate_Follow_Dark.png);
      }

      .followbase {
        display: inline-block;
        position: absolute;
        top: 4px;
        right: 4px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        vertical-align: middle;
      }
    }

    .device-item {
      position: relative;
      width: 100%;
      height: 124px;
      background: url(../../../assets/img/general/device-item-bgi.jpg) no-repeat;
      background-size: cover;
      background-position: center;
      margin-bottom: 25px;
      cursor: pointer;

      .device-item-mask {
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 78px;
        background: rgba(34, 45, 53, 0.8);
      }

      .device-item-info {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 78px;
        padding: 0 10px;
        color: rgba(255, 255, 255, 0.7);
        font-size: 18px;
        text-align: left;

        .device-item-namebox {
          display: block;
          margin-top: 6px;
          width: 100%;
          text-align: left;

          .device-item-name {
            display: inline-block;
            width: 70%;
            font-family: Microsoft YaHei;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
        // 跑马灯样式
        // .device-item-namebox {
        //   display: flex;
        //   align-items: center;
        //   margin-top: 6px;
        //   width: 100%;
        //   text-align: left;

        //   .device-item-name {
        //     display: flex;
        //     align-items: center;
        //     width: 70%;
        //     font-family: Microsoft YaHei;
        //     overflow: hidden;
        //     white-space: nowrap;
        //     vertical-align: middle;

        //     .marquee-text {
        //       display: inline-block;
        //       white-space: nowrap;
        //       font-size: 14px;
        //     }
        //   }
        // }
        .device-item-follow {
          display: none;
        }

        .device-item-idbox {
          display: block;
          margin-top: 2px;
          width: 100%;
          line-height: 1.2;
          margin-top: 0px;

          .device-item-id {
            display: inline-block;
            width: 102%;
            font-family: Microsoft YaHei;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 14px;
            // .item-num {}
          }
        }
      }
    }

    .device-item-easy {
      width: 100%;
      height: 55px;
      border-bottom: 1px solid #424e56;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;

      .device-item-namebox {
        display: block;
        margin-top: 6px;
        text-align: left;
        width: 85%;

        .device-item-name {
          display: inline-block;
          width: 70%;
          font-family: Microsoft YaHei;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        // 跑马灯样式
        // .device-item-name {
        //   display: inline-block;
        //   width: 70%;
        //   font-family: Microsoft YaHei;
        //   overflow: hidden;
        //   white-space: nowrap;
        //   vertical-align: middle;

        //   .marquee-text {
        //     display: inline-block;
        //     white-space: nowrap;
        //   }
        // }
      }

      .device-item-follow {
        display: none;

        .followbase {
          top: 6px;
        }
      }
    }

    .device-item:hover,
    .device-item-easy:hover {
      .showFollow {
        display: inline-block;
      }

      .device-item-follow {
        background: #858f97;
      }
    }

    .status-icon {
      width: 15px;
      height: 15px;
      margin-right: 10px;
      vertical-align: text-top;
    }

    .project-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background: rgba(34, 45, 53, 1);
      box-shadow: 0px 4px 23px rgba(58, 77, 90, 0.3) inset;

      /deep/button {
        display: block;
        width: 100%;
        height: 56px;
        line-height: 56px;
        border: none;
        border-radius: 0px;
        background: rgba(34, 45, 53, 1);
        color: #ffffff;
        font-size: 14px;
        padding: 0px;
        margin-bottom: 0px;
        box-shadow: 0px 4px 23px rgba(58, 77, 90, 0.3) inset;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;

        i {
          font-size: 24px;
          color: @primaryTextColor;
          vertical-align: middle;
        }
      }

      .project-line {
        width: 0.1px;
        height: 30px;
        border-width: 0.1px;
        border-style: solid;
        border-image-source: radial-gradient(
          57% 44.45% at 50% 50%,
          rgba(255, 255, 255, 1) 0%,
          rgba(34, 45, 53, 0) 100%
        );
        border-image-slice: 1;
        border-image-outset: 0.1px;
        margin: 0 4px;
      }
    }
  }

  .el-dropdown-pro {
    width: 100%;
    max-width: 206px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .showlabel {
      width: 100%;
      max-width: 247px;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0px;

      .countbox {
        width: 90%;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .pnamebox {
          // display: block;
          // text-align: left;
          width: 50%;
          // padding-top: 5px;
          margin-right: 5px;

          .pname {
            display: inline-block;
            padding-top: 5px;
            width: 100%;
            font-family: Microsoft YaHei;
            font-size: 16px;
            font-weight: bold;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
  }

  // 设备列表
  .proDeviceList {
    /deep/.el-table__empty-block {
      height: auto;
    }

    // 加载数据时遮罩
    /deep/.el-loading-mask {
      background-color: transparent;
    }

    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
  }

  // 新建项目(上传图片)
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }

  // 滚动条
  ::-webkit-scrollbar {
    width: 0px;
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
// 切换搜索类别下拉菜单
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

// 搜索类别图标(SN/PN)
.select-search-snpn {
  margin-top: 0px !important;

  .el-select-dropdown__item {
    height: 42px !important;
    line-height: 42px !important;
  }

  .el-select-dropdown__item.selected:before {
    content: "";
    top: 14px !important;
    right: 14px !important;
  }

  .ico-sn {
    background: url(../../../assets/img/general/Search_Select_Device.png);
  }

  .ico-pn {
    background: url(../../../assets/img/general/Search_Select_Datalogger.png);
  }

  .ico {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }
}

// 筛选下拉菜单
.select-search-pro {
  width: 200px;
  background: #222d35;
  font-family: Microsoft YaHei;
  border-radius: 6px;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border: none;

  .el-select-dropdown__wrap {
    max-height: 546px;
  }

  .el-select-group__wrap:not(:last-of-type)::after {
    height: 0px;
  }

  .el-select-group__title {
    padding-left: 16px;
    font-size: 14px;
    color: #ffffff;
    border-bottom: 1px solid #424e56;
    line-height: 39px;
    margin-top: 10px;
  }

  .el-select-dropdown__item {
    padding-left: 16px;
    font-size: 14px;
    text-align: left;
    background: #222d35;
    color: #ffffff;
    font-family: Microsoft YaHei;
  }

  .el-select-group__wrap {
    padding-bottom: 0px;
  }

  // .el-select-dropdown__item.hover {
  // }
  .el-select-dropdown__item:hover {
    background: #222d35;
    color: #ffffff;
  }

  .el-select-dropdown__item.selected:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    margin-right: 5px;
    position: absolute;
    top: 6px;
    right: 12px;
  }
}

// 切换项目的悬浮框
.el-dropdownmenu-pro {
  max-height: 80%;
  overflow: auto;
  // 起始位置跟随项目触发元素(placement=right-start)，不再固定top
  // overflow: hidden;
  background: #202d35;
  color: #ffffff;
  border-radius: 6px;
  border: none;
  padding: 10px 0px;
  // 限制宽度，文字过长时换行
  max-width: 280px;

  // min-width: 100px;
  // min-height: 30px;
  .el-dropdown-menu__item {
    background: #202d35;
    color: #ffffff;
    border: none;
    font-size: 16px;
    // 过长换行 + 内边距
    height: auto;
    line-height: 24px;
    padding: 6px 16px;
    white-space: normal;
    word-break: break-all;
  }

  .el-dropdown-menu__item.selected,
  .el-dropdown-menu__item:hover,
  .el-dropdown-menu__item:focus {
    background: #202d35;
    color: @primaryTextColor;
    border: none;
  }

  .el-dropdown-menu__item:hover {
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-dropdown-menu__item:not(:last-child) {
    border: none;
  }

  .popper__arrow {
    display: none;
  }

  &.el-popper[x-placement^="right"] {
    margin-left: 5px;
  }
}

.selectClearNew {
  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}
// 跑马灯样式
// @keyframes marquee-scroll {
//   0% {
//     transform: translateX(var(--marquee-start, 0px));
//   }
//   100% {
//     transform: translateX(var(--marquee-end, 0px));
//   }
// }
</style>
